import React from "react";
import { Button } from "@mui/material";
import { KeyValue, Query } from "../interfaces";

interface Props {
  appState: Query;
  updateUi: (
    filter: string,
    value: string | string[] | KeyValue[] | undefined,
  ) => void;
  updateFilters: (filter: string, value: string[]) => void;
  customComparison?: boolean;
}
function EditColumn({
  updateUi,
  updateFilters,
  customComparison,
  appState,
}: Props) {
  const step = appState.ui.comparisonType !== "" ? "step1" : "step2";
  const reportPeriodArray = appState.filters.reportPeriod;
  const reportPeriod = reportPeriodArray.length - 1;

  return (
    <Button
      id="edit-column"
      sx={
        customComparison
          ? {
              height: 40,
              marginTop: 4,
              marginBottom: 0,
              width: 160,
              fontSize: 16,
            }
          : { height: 40, marginTop: 8, marginBottom: 4, marginLeft: 8 }
      }
      variant="contained"
      color="secondary"
      onClick={() => {
        updateUi("pgcStep", step);
        updateUi("incomeBasis", ["YTD"]);
        updateUi("unitType", ["$"]);
        updateUi("reportType", undefined);
        updateUi("reportStructure", undefined);
        updateFilters("reportPeriod", [reportPeriodArray[reportPeriod]]);
      }}
    >
      Edit Columns
    </Button>
  );
}
export default EditColumn;
